import { Component } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
    selector: 'app-serviceManLayout',
    templateUrl: './serviceMan-layout.component.html',
    styleUrls: ['./serviceMan-layout.component.scss']
})

export class ServiceManLayoutComponent {
    
    user = this.authService.getServiceManUser();

    routes = [
        {
            path: 'freeModems',
            label: 'Modemi'
        },
        {
            path: 'login',
            label: `Odjavi se`
        }
    ];

    constructor(
        private authService: AuthService
    ) { }
}
